import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import React from 'react';

import { PixelExportType } from './PixelTypes';

function PixelExport(props: PixelExportType) {
    const {
        existingPixels,
        isSelected,
        handleRowClick
    } = props;
    return (
        <TableContainer sx={{ maxHeight: '300'}}>
            <Table>
                <TableHead sx={{ fontStyle: 'oblique'}}>
                    <TableRow>
                        <TableCell>
                            Client Name
                        </TableCell>
                        <TableCell>
                            Domain
                        </TableCell>
                        <TableCell>
                            Pixel ID
                        </TableCell>
                        <TableCell>
                            Created At
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {existingPixels?.map((row) => (
                        <TableRow
                            key={row.pixel_id}
                            onClick={(event) => handleRowClick(event.currentTarget, row.pixel_id)}
                            selected={isSelected(row.pixel_id)}>
                            <TableCell>
                                {row.client_name}
                            </TableCell>
                            <TableCell>
                                {row.client_domain}
                            </TableCell>
                            <TableCell>
                                {row.pixel_id}
                            </TableCell>
                            <TableCell>
                                {new Date(row.created_at).toLocaleString()}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default PixelExport;
